import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';


const RegistrationRequestDetails = ({ registrationResources }) => {

    return (
        <>
            {
                registrationResources.map((resource, index) =>
                    <Paper key={index} className="detail-wrapper">
                        <Typography variant="button" display="block" gutterBottom>
                            {resource.destinationCityName}, {resource.conferenceName} Conference
                                </Typography>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {resource.noofCustomers} Customers, {resource.registrationDate.substring(0, 10)},  {resource.registrationType}
                        </Typography>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            {resource.dueDate ? `Due Date ${resource.dueDate.substring(0, 10)}` : ''}
                        </Typography>
                        {
                            resource.note && resource.note.trim() !== "" ?
                                <Typography variant="body2" display="block" gutterBottom>
                                    Notes: {resource.note}
                                </Typography>
                                : null
                        }
                    </Paper>
                )
            }
        </>
    )
}

export default RegistrationRequestDetails;